import { Fragment, useContext } from 'react';

import type { ContentfulConditionalComponentFragment } from '@/graphql/contentful/api';
import {
  type CmsExtraDataRecord,
  filterContentfulCollection,
  generateSectionKey,
  renderContentfulSection,
} from '@/integrations/contentful';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';

export type ConditionalComponentProps =
  ContentfulConditionalComponentFragment & {
    extraDataRecord?: CmsExtraDataRecord;
    isAuthenticated?: null | boolean;
    isNotEmpty?: boolean;
  };

export const ConditionalComponent = ({
  displayOnEmptyCondition,
  displayOnLoggedInCondition,
  extraDataRecord,
  isAuthenticated,
  isNotEmpty,
  ...props
}: ConditionalComponentProps) => {
  const draftMode = useContext(DraftModeContext);
  const cmsData = filterContentfulCollection(props.contentCollection?.items);

  const conditionNotEmptyResult: boolean =
    displayOnEmptyCondition === undefined || displayOnEmptyCondition === null
      ? true
      : isNotEmpty ===
        (displayOnEmptyCondition === 'Display Only if Not Empty');

  const conditionOnLoggedInResult: boolean =
    displayOnLoggedInCondition === undefined ||
    displayOnLoggedInCondition === null
      ? true
      : !!isAuthenticated ===
        (displayOnLoggedInCondition === 'Display Only if Logged In');

  return conditionNotEmptyResult && conditionOnLoggedInResult ? (
    <>
      {cmsData?.map((data, i) => (
        <Fragment key={generateSectionKey(data, i)}>
          {renderContentfulSection(data, undefined, extraDataRecord, draftMode)}
        </Fragment>
      ))}
    </>
  ) : null;
};
